import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/themes"

export const Cashmere25FacetListButtonText = styled("div")<{$isOnSecondRow?: boolean}>`
    text-align: left;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    line-height: 1.2rem;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    max-height: 2.4rem;
    word-wrap: break-word;
    font-weight: ${({theme}) => `${theme.colours.components.inputText.fontWeight}`};
    font-size: ${({theme}) => `${theme.colours.components.inputText.fontSize}`};
    font-family: ${({theme}) => `${theme.colours.components.inputText.fontFamily}`};
    letter-spacing: ${({theme}) => `${theme.colours.components.inputText.letterSpacing}`};
    @media (min-width: ${breakpoints.values.md}px) {
        -webkit-line-clamp: 1;
        max-height: 1.2rem;
        max-width: 5rem;
    }
    @media (min-width: 1100px) {
        max-width: 6rem;
    }
`
export default Cashmere25FacetListButtonText
